import { FieldDescriptor, EntityTablePage, EntityTablePageProps, Utils, AppContainer, EntityTablePageState, EntityTablePageReducers } from "@crispico/foundation-react";
import { Severity } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { addAfterStartupRunnable } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { addEntityDescriptor, EntityDescriptor } from "@crispico/foundation-react/entity_crud/EntityDescriptor";
import { SliceEntityEditorPage } from "@crispico/foundation-react/entity_crud/EntityEditorPage";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { createSliceFoundation } from "@crispico/foundation-react/reduxHelpers";
import { SAVE_USER, SAVE_USER_OPERATION_NAME } from "./queries";
import { UserEditorPage } from "./UserEditorPage";
import { FieldIntervalColoring } from "@crispico/foundation-react/entity_crud/CrudSettings";
import { DatePickerFieldEditor } from "@crispico/foundation-react/entity_crud/fieldEditors/DatePickerFieldEditor";
import { ReduxReusableComponents } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";

export let userEntityDescriptor: EntityDescriptor;
export class SliceUserEditor extends SliceEntityEditorPage {
    handleDataReturnedBySaveOperation(dataReturnedBySave: any): void {
        if (dataReturnedBySave[SAVE_USER_OPERATION_NAME].notificationMessage) {
            Utils.showGlobalAlert({ message: dataReturnedBySave[SAVE_USER_OPERATION_NAME].notificationMessage, severity: Severity.INFO });
        }
    }

    getSaveOperationName(): string {
        // We override it because by default is 'userService_save'
        return SAVE_USER_OPERATION_NAME;
    }

    /**
     * Meant to be overwritten
     */
    shouldOverrideSaveMutationEntirely(): boolean {
        return true;
    }

    initQueries() {
        super.initQueries();
        if (this.shouldOverrideSaveMutationEntirely()) {
            this.saveMutation = SAVE_USER;
        }
    }

    /**
     * TODO DB: Temporary untill the mechanism for displaying the validation errors will be implemented
     */
    isDefaultErrorHandlerShownInCaseOfValidationException(): boolean {
        return true;
    }
}

class UserTablePage extends EntityTablePage<EntityTablePageProps> {
    protected onCloseEntityEditorInline(withRefresh?: boolean) {
        let { initialFormikValues } = this.props.s.actionParam ?
            this.getParamsForEntityEditorInline(this.entityTableSimpleRef.currentNotNull.getEntity(this.props.s.actionParam!.selection[0]), this.props.s.actionParam!.currentField) : {} as any;
        
        if (initialFormikValues.id === this.context.initializationsForClient.currentUser?.id) {
            AppContainer.INSTANCE.props.onSoftReload();
        }

        super.onCloseEntityEditorInline(withRefresh);
    }
}

const UserTablePageRRC = ReduxReusableComponents.connectRRC(EntityTablePageState, EntityTablePageReducers, UserTablePage);

addAfterStartupRunnable(() => {
    class UserEntityDescriptor extends EntityDescriptor {
        constructor() {
            super({
                name: "User",
                icon: "user",
                miniFields: ["username"]
            });
        }

        renderTable() {
            return <UserTablePageRRC {...super.renderTable().props} ref={this.entityTablePage} />;
        }
    }

    userEntityDescriptor = addEntityDescriptor(new UserEntityDescriptor()
        .addFieldDescriptor({ name: "id", type: FieldType.number, enabled: false })
        .addFieldDescriptor({ name: "username", type: FieldType.string })
        .addFieldDescriptor({ name: "email", type: FieldType.string })
        .addFieldDescriptor({ name: "firstName", type: FieldType.string })
        .addFieldDescriptor({ name: "lastName", type: FieldType.string })
        .addFieldDescriptor({ name: "language", type: FieldType.dropdown })
        .addFieldDescriptor({ name: "isAdmin", type: FieldType.boolean, adminOnly: true })
        .addFieldDescriptor({ name: "lastLoginDate", type: FieldType.date, additionalFieldEditorProps: FieldDescriptor.castAdditionalFieldEditorProps(DatePickerFieldEditor, { relativeColoring: true }), fieldDescriptorSettings: {
            fieldIntervals: [
                { from: null, to: "-24 hours", color: '#F32222', applyColorTo: FieldIntervalColoring.BACKGROUND }, { from: "-24 hours", to: "-60 minutes", color: '#F38A22', applyColorTo: FieldIntervalColoring.BACKGROUND }, { from: "-60 minutes", to: null, color: '#22F329', applyColorTo: FieldIntervalColoring.BACKGROUND }
            ]}
        })
        .addFieldDescriptor({ name: "resetKey", type: FieldType.string })
        .addFieldDescriptor({ name: "resetDate", type: FieldType.date })
        .addFieldDescriptor({ name: "passwordExpires", type: FieldType.boolean, initialValue: true })
        .addFieldDescriptor({ name: "passwordChangedDate", type: FieldType.date })
        .addFieldDescriptor({ name: "failedLoginAttempts", type: FieldType.number })
        .addFieldDescriptor({ name: "isLocked", type: FieldType.boolean })
        .addFieldDescriptor({ name: "creationDate", type: FieldType.date })
        .addFieldDescriptor({ name: "mfaEnabled", type: FieldType.boolean, adminOnly: true })
        .doForFields(["resetKey", "resetDate", "passwordChangedDate", "creationDate"],
            fieldDescriptor => { fieldDescriptor.isInDefaultColumnConfigForTable = false; fieldDescriptor.isInDefaultColumnConfigForEditor = false; })
        .removeFieldDescriptors("newPassword", "screen", "screenposition", "pricesAvailable", "showDoneTasksInFlightGantt", "showDoneTasksInMissionGantt", "unit", "initialConfiguration")
        .isInDefaultColumnConfig(true, "username", "lastLoginDate", "firstName", "lastName", "email", "language", "passwordExpires")
    );

    const sliceUserEditor = createSliceFoundation(SliceUserEditor);
    userEntityDescriptor.infoEditor.slice = sliceUserEditor;
    sliceUserEditor.setEntityDescriptor(userEntityDescriptor);

    userEntityDescriptor.infoEditor.wrappedComponentClass = UserEditorPage;
})"../..""../../components/ModalExt/ModalExt""../../entity_crud/entityCrudConstants""../../entity_crud/EntityDescriptor""../../entity_crud/EntityEditorPage""../../entity_crud/FieldType""../../reduxHelpers""../../entity_crud/CrudSettings""../../entity_crud/fieldEditors/DatePickerFieldEditor""../../reduxReusableComponents/ReduxReusableComponents"